import {useContextState as useUserContext} from '../../../../../../context/user';
import {useSalesmanContext} from '../../../../../../context/salesman';
import {useContextState as useSubClientContext} from '../../../../../../context/sub-client';
import {Role} from '../../../../../../constants/enumerations';

export const useHistoryList = () => {
  const {profile} = useUserContext();

  const {fetchHistoryList: fetchSubClientHistory, history: clientHistory} =
    useSubClientContext();
  const {fetchHistoryList: fetchCustomerHistory, history: customerHistory} =
    useSalesmanContext();

  const fetchHistoryList = async (): Promise<boolean> => {
    if (profile?.role === Role.salesman) {
      return fetchCustomerHistory();
    }
    return fetchSubClientHistory();
  };

  const historyList =
    profile?.role === Role.salesman ? customerHistory : clientHistory;

  return {fetchHistoryList, historyList};
};
